import React, { FC, useEffect, useState } from "react";
import WidgetHeading1 from "./WidgetHeading1";
import Tag from "shared/Tag/Tag";


export interface WidgetTagsProps {
  className?: string;
  tags?: any[];
  loading?: boolean;
}

const WidgetTags: FC<WidgetTagsProps> = ({
  className = "border border-neutral-200 dark:border-neutral-700",
  tags: propTags,
  loading: propLoading,
}) => {
  const [fetchedTags, setFetchedTags] = useState<any[]>([]);
  const [fetchLoading, setFetchLoading] = useState(propTags === undefined);

  useEffect(() => {
    if (propTags !== undefined) return;
    fetch(`${process.env.REACT_APP_API_URL}/posts/tags`)
      .then(r => r.json())
      .then(setFetchedTags)
      .catch(err => console.error('Error fetching tags:', err))
      .finally(() => setFetchLoading(false));
  }, [propTags]);

  const tags = propTags ?? fetchedTags;
  const loading = propLoading ?? fetchLoading;

  return (
    <div
      className={`nc-WidgetTags rounded-2xl overflow-hidden ${className}`}
      data-nc-id="WidgetTags"
    >
      <WidgetHeading1
        title="태그 모아보기"
        viewAll={{ label: "전체보기", href: "/blog-list" }}
      />
      <div className="flex flex-wrap p-4 xl:p-5">
        {loading ? (
          [...Array(8)].map((_, i) => (
            <div
              key={i}
              className="mr-2 mb-2 h-8 rounded-lg bg-neutral-200 dark:bg-neutral-700 animate-pulse"
              style={{ width: `${60 + (i % 3) * 20}px` }}
            />
          ))
        ) : (
          tags
            .filter((_, i) => i < 14)
            .map((tag) => (
              <Tag className="mr-2 mb-2" key={tag.id} tag={tag} />
            ))
        )}
      </div>
    </div>
  );
};

export default WidgetTags;
